import React from "react";
import { BLOCKS, INLINES, MARKS } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Img from "gatsby-image";
import AniLink from "gatsby-plugin-transition-link/AniLink";

import { useContentfulImage } from "utils/hooks";
import Heading from "components/Heading";

import "./_rich-text-renderer.scss";

const options = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: node => {
      const fluid = useContentfulImage(
        node.data.target.fields.file["en-US"].url
      );
      return (
        <Img
          alt={node.data.target.fields.title["en-US"]}
          title={node.data.target.fields.title["en-US"]}
          fluid={fluid}
          className="rich-text-renderer__image"
        />
      );
    },
    [BLOCKS.HEADING_2]: (node, children) => (
      <Heading headingLevel="h2">{children}</Heading>
    ),
    [BLOCKS.HEADING_3]: (node, children) => (
      <Heading headingLevel="h3">{children}</Heading>
    ),
    [BLOCKS.HEADING_4]: (node, children) => (
      <div className="rich-text-renderer__h4-wrapper">
        <Heading headingLevel="h4">{children}</Heading>
      </div>
    ),
    [BLOCKS.HEADING_5]: (node, children) => (
      <Heading headingLevel="h5">{children}</Heading>
    ),
    [BLOCKS.HEADING_6]: (node, children) => (
      <Heading headingLevel="h6">{children}</Heading>
    ),
    [INLINES.HYPERLINK]: (node, children) => (
      <AniLink
        cover
        duration={1.5}
        bg="#3e563e"
        className="rich-text-renderer__hyperlink"
        to={node.data.uri}
      >
        {children}
      </AniLink>
    ),
  },
  renderMark: {
    [MARKS.BOLD]: text => <span className="bold">{text}</span>,
  },
};

export default ({ richTextJson }) =>
  documentToReactComponents(richTextJson, options);
